import { ProcessComparison } from '@helpers/Enums';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Select } from 'antd';
import React, { useEffect, useState } from 'react';

import { GhostButton } from './WorkflowConditionsModalStyles';

const trash = require('../workflowAssets/trash.svg')

interface PropType {
  component: any;
  operation: any;
  comparisonValue: any;
  handleInput: Function;
  handleComparison: Function;
  deleteRule: Function;
  availableProcess: any;
  handleComponent: Function;
  handleSection: Function;
  component_id: any;
  value: any;
  componentList?: any;
  optionListRule?: any;
  sectionSelected?: string;
}

export default function ConditionRules(props: PropType) {
  
  const { 
    handleInput, 
    value, 
    operation,  
    handleComparison, 
    deleteRule, 
    availableProcess, 
    handleComponent,
    component_id,
    handleSection,
    sectionSelected} = props;
  const { Option } = Select
  
  
  const [optionListRule, setOptionsListRule] = useState([]);
  const [componentList, setcomponentList] = useState([]);

  useEffect(() => {
    createComponentList(sectionSelected)
  }, [props])


  function createComponentList (processId: any){
    const { availableProcess, component_id } = props;

    const componentsRule = availableProcess.sections.filter((obj: any) => obj.id === processId)
    const componentList: any = [];
    const optionListRule: any = [];
    if(componentsRule !== undefined){
      for(let components of componentsRule){
        for(let component of components.components){
          componentList.push(component);
          if(component.id === component_id){
            for(let option of component.options){
              optionListRule.push(option) 
            }
          }
        }
      }
    }
    setOptionsListRule(optionListRule);
    setcomponentList(componentList);

  }
  
  return (
    <RuleContainer>
      <span className="condition-desc">{I18n.l('workflow.condition.answer')}</span>
      
      <div className="input-container">
        <Select value={sectionSelected} onChange={handleSection} id="condition-component" placeholder={I18n.l('common.component.select')}>
        {availableProcess.sections.map((section: any) => 
          <Option value={section.id} key={`${section.id}-id`}>{section.title}</Option>)}
        </Select>
      </div>
      
      <div className="input-container">
        <Select value={component_id} id="component-list" onChange={handleComponent} placeholder={I18n.l('common.component.select')}>
        {componentList && componentList.map((section: any) => 
          <Option value={section.id} key={`${section.id}-components-id`}>{section.title}</Option>)}
        </Select>
      </div>
      
      <div className="input-container">
        <Select id="operation-select" value={operation} onChange={handleComparison}>
          <Option key={ProcessComparison.EQUAL} value={ProcessComparison.EQUAL}>{I18n.l('formflow.conditions.equals')}</Option>

          <Option key={ProcessComparison.DIFFERS} value={ProcessComparison.DIFFERS}>{I18n.l('formflow.conditions.notEquals')}</Option>
        </Select>
      </div>
      
      
      <div className="input-container">
        <Select value={value} onChange={handleInput} id="optionsComponent-list" placeholder={I18n.l('common.component.select')}>
        {optionListRule && optionListRule.map((section: any) => 
          <Option value={section.value} key={`${section.id}-id`}>{section.value}</Option>)}
        </Select>
      </div>

      <div onClick={deleteRule} id='delete-rule' className="delete-container">
        <img className="delete-icon" src={trash} />
        <GhostButton color="#D93838" className="delete">{I18n.l('common.delete')}</GhostButton>
      </div>

    </RuleContainer>
  )
}

const RuleContainer = styled.div`
  width: 95%;
  margin: 0 auto;
  height: 70px;
  background-color: #D9EBF9;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin: 20px 0;

  .condition-desc{
    color: #000000;
    margin: 10px 10px 10px 45px;
    font-size: 1.0em;
  }
  
  .input-container{
    display: flex;
    flex: 1;
    justify-content: center;
    .input{
      width: 10vw;
      border-radius: 5px;
      height: 25px;
      box-sizing: border-box;
      border: 1px solid #C8C8C8;
      padding: 10px 20px;
    }
    .ant-select-selection{
      width: 13vw;
      @media (max-width: 1370px) {
            width: 11vw;
        }
      box-sizing: border-box;
      padding: 20px;
      height: 30px;
      .ant-select-selection__placeholder{
        top: 8%
      }
    }
    .ant-select-selection-selected-value {
      float: none;
      transform: translateY(-49%);
    }
  }
  .delete-container{
    white-space: nowrap;
    margin-right: 2%;
    :hover{
      cursor: pointer;
    }
    .delete-icon{
      transform: translate(-1px, -4px);
    }
  }

`
